import { render, staticRenderFns } from "./EmailVerifyV.vue?vue&type=template&id=2997be3a"
import script from "./EmailVerifyV.vue?vue&type=script&lang=js"
export * from "./EmailVerifyV.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports